import queryKeys from '@/constants/queryKeys';
import { deleteContent } from '@/services/api/requests/content';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useDeleteContent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (contentId: string) => deleteContent(contentId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.mine] });
    },
  });
};

export default useDeleteContent;
